import { getResponseStatus } from "@istari-frontend/shared";

/**
 * The registry mounts its inbox routes only when eventing is on, so a 404 from an inbox list
 * route means the deployment has no inbox. Resolves to `null` in that case.
 */
export async function orNullWithoutInbox<T>(request: Promise<T>): Promise<T | null> {
  try {
    return await request;
  } catch (error) {
    if (getResponseStatus(error) === 404) {
      console.info("[notifications] inbox list answered 404; notifications are off for this session");
      return null;
    }
    throw error;
  }
}

/** `enabled` predicate that stops fetching once an inbox query has resolved to `null`. */
export function hasInbox(query: { state: { data: unknown } }): boolean {
  return query.state.data !== null;
}
